<template>
  <div class="loader">
    <img class="loader__icon h-24 w-24" src="@/assets/images/brand/logo.svg" />
    <p class="loading">{{ $t('dashboard.loading') }}</p>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';

export default {
  name: 'Loader',
  methods: {
    ...mapMutations('auth', ['clearAuth', 'setLogoutBlocked']),
  },
  // The following lines are temporarily commented out as they were causing the logout
  // button to be disabled for 2-3 seconds during each route change. Further investigation
  // and refinement are needed to address this issue before uncommenting these lines.
  // mounted() {
  //    this.setLogoutBlocked(true);
  // },
  beforeDestroy() {
    this.setLogoutBlocked(false);
  },
};
</script>

<style lang="scss" scoped>
.loader {
  @apply flex flex-col justify-center items-center w-full pt-24;
  min-height: 50vh;

  &__icon {
    animation: pulse 1.8s linear infinite both;
  }

  .loading {
    @apply text-xl mt-3;

    &::after {
      content: ".";
      animation: loading 1.2s ease alternate infinite;
    }
  }
}

@keyframes loading {
  60% {
    text-shadow: 0.3em 0 0 #000;
  }

  100% {
    text-shadow: 0.3em 0 0 #000, 0.6em 0 0 #000;
  }
}

@keyframes pulse {
  0% {
    transform: scale(0.4);
  }

  50% {
    transform: scale(0.6);
  }

  100% {
    transform: scale(0.4);
  }
}</style>
